import { render, staticRenderFns } from "./PersonEditCard.vue?vue&type=template&id=13b3fc82&scoped=true&"
import script from "./PersonEditCard.vue?vue&type=script&lang=js&"
export * from "./PersonEditCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonEditCard.vue?vue&type=style&index=0&id=13b3fc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3fc82",
  null
  
)

export default component.exports